// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarSync_wrapper__EbabO {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.CalendarSync_label__TX\\+iP {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
  margin: 0;
}

.CalendarSync_buttonsRow__mmjqc {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.CalendarSync_hiddenCheckbox__0GkaJ {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
  margin: 0;
  overflow: hidden;
}

.CalendarSync_validationBox__WgqdD {
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: #fef2f2;
  border: 1px solid #ef4444;
  border-radius: 6px;
  margin-top: 8px;
  gap: 8px;
}

.CalendarSync_validationText__yLCbE {
  font-size: 13px;
  color: #dc2626;
  margin: 0;
  font-weight: 500;
}

.CalendarSync_connectNowBtn__uWuYd {
  align-self: flex-start;
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/CalendarSync/CalendarSync.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AACD;;AAEA;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AACD;;AAEA;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AACD;;AAEA;EACC,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;AACD;;AAEA;EACC,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AACD;;AAEA;EACC,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AACD","sourcesContent":[".wrapper {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n}\r\n\r\n.label {\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 500;\r\n\tcolor: var(--primary-Text);\r\n\tmargin: 0;\r\n}\r\n\r\n.buttonsRow {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 8px;\r\n\talign-items: center;\r\n}\r\n\r\n.hiddenCheckbox {\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\tpointer-events: none;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tmargin: 0;\r\n\toverflow: hidden;\r\n}\r\n\r\n.validationBox {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tpadding: 12px;\r\n\tbackground-color: #fef2f2;\r\n\tborder: 1px solid #ef4444;\r\n\tborder-radius: 6px;\r\n\tmargin-top: 8px;\r\n\tgap: 8px;\r\n}\r\n\r\n.validationText {\r\n\tfont-size: 13px;\r\n\tcolor: #dc2626;\r\n\tmargin: 0;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.connectNowBtn {\r\n\talign-self: flex-start;\r\n\tpadding: 6px 14px;\r\n\tfont-size: 13px;\r\n\tborder-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CalendarSync_wrapper__EbabO`,
	"label": `CalendarSync_label__TX+iP`,
	"buttonsRow": `CalendarSync_buttonsRow__mmjqc`,
	"hiddenCheckbox": `CalendarSync_hiddenCheckbox__0GkaJ`,
	"validationBox": `CalendarSync_validationBox__WgqdD`,
	"validationText": `CalendarSync_validationText__yLCbE`,
	"connectNowBtn": `CalendarSync_connectNowBtn__uWuYd`
};
export default ___CSS_LOADER_EXPORT___;
